import {useLocation} from '@eitje/bridge'
import {NewForm, useForm} from '@eitje/form'
import utils from '@eitje/utils'
import {useEffect} from 'react'
import {LegacyModal} from '../../legacy_modal'
import {useLegacyModalContext} from '../../modal_context'
import {LegacyFormModalSubmitButton} from './buttons'

const Inner = ({modalProps = {}}) => {
	const {okButtonProps = {}, watch, ...rest} = modalProps
	const {setModalPropsRaw} = useLegacyModalContext()
	const {submit, getData, form} = useForm()
	const loc = useLocation()

	useEffect(() => {
		setModalPropsRaw({
			form: true,
			FooterSubmitButton: LegacyFormModalSubmitButton,
			okButtonProps: {...okButtonProps, form, submit, getData},
			...rest,
		})
	}, [loc.pathname, JSON.stringify(okButtonProps), watch])

	return null
}

/** @deprecated Use FormModal from @eitje/web_components instead. */
export const LegacyFormModal = ({name, width, className, modalProps, ...props}) => {
	const classNames = utils.makeCns('eitje-form-3-modal', className)
	return (
		<LegacyModal name={name} width={width} className={classNames} {...modalProps} form>
			<LegacyModalForm {...props} modalProps={modalProps} />
		</LegacyModal>
	)
}

/** @deprecated Use FormModal from @eitje/web_components instead. */
export const LegacyModalForm = ({children, modalProps, ...props}) => {
	const {names} = useLegacyModalContext()

	return (
		<NewForm name={names} {...props}>
			<Inner modalProps={modalProps} />
			{children}
		</NewForm>
	)
}
